// Inventory-related type definitions

export interface InventoryItem {
  id: string;
  user_id: string;
  item_name: string;
  item_description?: string;
  condition: ItemCondition;
  suggested_price?: number;
  purchase_date?: string;
  purchase_price?: number;
  purchase_location?: string;
  inventory_section: 'keep' | 'for_sale';
  ai_analysis?: AIAnalysis;
  images: string[];
  item_sales?: ItemSale[];
  created_at: string;
  updated_at: string;
}

export interface ItemSale {
  id: string;
  item_id: string;
  marketplace: string;
  sale_price: number;
  sale_date: string;
  notes?: string;
  created_at: string;
}

export interface Marketplace {
  id: string;
  name: string;
  url?: string;
  category?: string;
  created_at: string;
}

export interface ItemMarketplace {
  id: string;
  item_id: string;
  marketplace_id: string;
  success_rate?: number;
  created_at: string;
  marketplace?: Marketplace; // Populated when joined
}

export enum ItemCondition {
  EXCELLENT = 'excellent',
  VERY_GOOD = 'very_good',
  GOOD = 'good',
  FAIR = 'fair',
  POOR = 'poor'
}

export interface AIAnalysis {
  title: string;
  description: string;
  condition_analysis: string;
  market_research: MarketResearch;
  generated_at: string;
}

export interface MarketResearch {
  suggested_price: number;
  price_range: {
    min: number;
    max: number;
  };
  top_marketplaces: MarketplaceRecommendation[];
  market_trends: string[];
}

export interface MarketplaceRecommendation {
  marketplace: string;
  success_rate: number;
  average_price: number;
  notes: string;
}

export interface InventoryStats {
  total_items: number;
  total_value: number;
  sold_items: number;
  sold_value: number;
  unsold_items: number;
  unsold_value: number;
}

export interface CreateInventoryItemRequest {
  item_name: string;
  images: File[];
  user_description?: string;
}

export interface UpdateInventoryItemRequest {
  item_name?: string;
  item_description?: string | null;
  condition?: ItemCondition;
  suggested_price?: number | null;
  purchase_date?: string | null;
  purchase_price?: number | null;
  purchase_location?: string | null;
  inventory_section?: 'keep' | 'for_sale';
}

export interface CreateSaleRequest {
  item_id: string;
  marketplace: string;
  sale_price: number;
  sale_date: string;
  notes?: string;
}

export interface InventoryFilters {
  condition?: ItemCondition;
  min_price?: number;
  max_price?: number;
  sold_status?: 'sold' | 'unsold' | 'all';
  date_from?: string;
  date_to?: string;
}
